import React, { memo, useCallback } from "react";

import {
  Button,
  Center,
  HStack,
  Modal,
  ModalBody,
  ModalContent,
  ModalHeader,
  ModalOverlay,
  Text,
  VStack,
} from "@chakra-ui/react";
import { useApolloClient, useMutation } from "@apollo/client";
import {
  DeleteAllJobsMutation,
  DeleteAllJobsMutationVariables,
  JobListQuery,
} from "gql/graphql";
import DELETE_ALL_JOBS_MUTATION from "modules/drawers/networking/delete-all-jobs";
import JOB_LIST_QUERY from "modules/drawers/networking/job-list";
import { useOverlay } from "modules/providers/overlay-provider";

const DeleteJobsModal = () => {
  const { closeModal } = useOverlay();
  const { cache } = useApolloClient();

  const [deleteAllJobsAPI] = useMutation<
    DeleteAllJobsMutation,
    DeleteAllJobsMutationVariables
  >(DELETE_ALL_JOBS_MUTATION);

  const onDeleteClicked = useCallback(() => {
    deleteAllJobsAPI();
    cache.updateQuery<JobListQuery>(
      {
        query: JOB_LIST_QUERY,
      },
      (data) => {
        if (!data) {
          return data;
        }
        return {
          ...data,
          jobList: [],
        };
      },
    );
    closeModal();
  }, [deleteAllJobsAPI, cache, closeModal]);

  return (
    <Modal isOpen onClose={closeModal} size="xs" isCentered>
      <ModalOverlay />
      <ModalContent borderRadius={16}>
        <ModalHeader pt={6} pb={0}>
          <Center>
            <Text>Clear History</Text>
          </Center>
        </ModalHeader>
        <ModalBody pb={6}>
          <VStack>
            <Text fontSize={14}>
              Are you sure you want to clear all of your downloads and exports?
            </Text>
            <HStack>
              <Button variant="cancel" height={50} w={28} onClick={closeModal}>
                Cancel
              </Button>
              <Button height={50} w={28} onClick={onDeleteClicked}>
                Clear
              </Button>
            </HStack>
          </VStack>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};

export default memo(DeleteJobsModal);
